export default __webpack_public_path__ + "static/media/complementary--one-direction-right--g1.ef8aa050.png";